import type { ClientLifecycleStatus } from '~/types/models';

const clientQuickCreateOpen = ref(false);
const clientQuickCreateLifecycle = ref<ClientLifecycleStatus>('raw_enquiry');

export function useClientQuickCreate() {
    function openClientQuickCreate(lifecycleStatus: ClientLifecycleStatus = 'raw_enquiry') {
        clientQuickCreateLifecycle.value = lifecycleStatus;
        clientQuickCreateOpen.value = true;
    }

    function closeClientQuickCreate() {
        clientQuickCreateOpen.value = false;
    }

    return {
        isClientQuickCreateOpen: clientQuickCreateOpen,
        clientQuickCreateLifecycle,
        openClientQuickCreate,
        closeClientQuickCreate,
    };
}
